<template>
  <dialog id="modalBagEditor" open>
    <h1>Big Bag {{ element.uniqueNumber }}</h1>
    <form class="row">
      <div class="input-group col-8 mb-3 required">
        <div class="input-group-prepend">
          <label class="input-group-text" for="regraterId">Aufkäufer</label>
        </div>
        <select
            v-model="regraterId"
            class="custom-select custom-select-lg" id="regraterId">
          <option value=""></option>
          <option
              v-for="regrater in regraters"
              :key="regrater.contactId"
              :value="regrater.contactId">{{ regrater.name }}
          </option>
        </select>
      </div>
      <div v-if="showStockLocation" class="input-group col-8 mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="stockLocation">Lagerort</label>
        </div>
        <input v-model="stockLocation" type="string" class="form-control form-control-lg"
               id="stockLocation" placeholder="">
      </div>
      <div class="input-group col-8 mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="dryNumber">BB-Nummer</label>
        </div>
        <input v-model="dryNumber" type="number" step="1" class="form-control form-control-lg"
               id="dryNumber" placeholder="">
      </div>
      <div class="input-group col-8 mb-3 required">
        <div class="input-group-prepend">
          <label class="input-group-text" for="dryWeight">Trocken</label>
        </div>
        <input v-model="weight" type="number" step="1" class="form-control form-control-lg"
               id="dryWeight" placeholder="" :disabled="!(workflowState === 50)">
        <div class="input-group-append">
          <span class="input-group-text">kg</span>
        </div>
      </div>

      <div v-if="useContractPressing">
        <div class="input-group form-check mt-1">
          <input v-model="contractPressing" type="checkbox" class="form-check" id="contractPressing">
          <label class="form-check-label ml-2" for="contractPressing">Lohnpressung</label>
        </div>
      </div>
<!--      <div class="input-group col-8 mb-3">-->
<!--        <div class="input-group-prepend">-->
<!--          <label class="input-group-text" for="regraterId">Aufgefüllt in</label>-->
<!--        </div>-->
<!--        <select-->
<!--            v-model="parent_vesselId"-->
<!--            class="custom-select custom-select-lg" id="parent_vesselId"-->
<!--        >-->
<!--          <option value=""></option>-->
<!--          <option-->
<!--              v-for="parent in fillableVessels"-->
<!--              :key="parent.vesselId"-->
<!--              :value="parent.uniqueId">{{ parent.uniqueNumber }} {{ parseInt(parent.weight) }} kg-->
<!--          </option>-->
<!--        </select>-->
<!--      </div>-->
    </form>
    <div class="row mt-1 buttons">
      <div class="col-3">
        <button @click="abortDialog" type="reset">Abbrechen</button>
      </div>
      <div class="col-5">
        <button @click="confirmDialog" type="submit">Speichern</button>
      </div>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "PopupBagEditor",
  data() {
    return {
      weight: null,
      regraterId: null,
      stockLocation: null,
      dryNumber: null,
      contractPressing: false,
      // fillableVessels: []
    }
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    regraters: {
      type: Array,
      required: true
    },
    showStockLocation: {
      type: Boolean,
      default: false
    },
    workflowState: {
      type: Number,
      required: false
    },
  },
  created() {
    this.weight = this.$props.element.weight
    this.regraterId = this.$props.element.regraterId
    this.stockLocation = this.$props.element.stockLocation
    this.dryNumber = this.$props.element.number > 0 ? this.$props.element.number : null
    this.contractPressing = this.$props.element.contractPressing == true || parseInt(this.$props.element.contractPressing) == 1

    // load fillable vessels and include parent vessel
  },
  computed: {
    useContractPressing() {
      return this.$store.getters.contractPressing
    },
  },
  methods: {
    abortDialog() {
      this.$emit('abortDialog')
    },
    confirmDialog() {
      let element = {
        id: this.$props.element.vesselId,
        regraterId: this.regraterId,
        weight: this.weight,
        number: this.dryNumber,
        contractPressing: this.contractPressing,
      }
      if (this.$props.showStockLocation)
        element['stockLocation'] = this.stockLocation

      this.$emit('confirmDialog', element)
    }
  }
}
</script>

<style scoped>
dialog {
  z-index: 1000;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  border: 0;
  padding: 10vh 1.5rem 0;
}

dialog .buttons div:first-of-type {
  padding-left: 0;
}

dialog .buttons div:last-child {
  padding-right: 0;
}
</style>